var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 15,
    ry: 15,
    fill: "#FFBA08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 L30 70 L45 70 L45 55 L55 70 L70 70 L55 50 L70 30 L55 30 L45 45 L45 30 Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30 L45 45 L55 45 A5 5 0 0 0 55 35 L45 35 Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 45 L68 55 L78 55 L70 61 L73 70 L65 65 L57 70 L60 61 L52 55 L62 55 Z",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGta);
export default __webpack_public_path__ + "static/media/gta.e9e67ac80f7233202807303e10472e25.svg";
export { ForwardRef as ReactComponent };